import { registryFilter } from './../../../../pipes/filter.pipe';
import { UserRolesService } from '../../../../services/user.roles.service';
import { LicenseManager } from '../../../../managers/License.manager';
import { LiveHubService } from './../../../../services/livehub.service';
import { Component, OnInit, Input } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../../services/ss-api.service';
import { RegistrySubKeyItemArray, RegistryValueItemArray } from '../../../../models/livehub/registry';
import { AdminHubRegistryRequest } from '../../../../models/ss-api/requests/admin.hub.registry.request';
import { DialogService } from '../../../../services/modal-dialogs';
import { AddRegistryValueDialog } from '../../../../dialogs/add.registry.value/add.registry.value.dialog';

@Component({
    selector: 'registry-editor',
    templateUrl: './registry.editor.component.html',
    styleUrls: ['./registry.editor.component.scss']
})

export class RegistryEditorComponent implements OnInit {
    IsBusy: boolean = false;

    @Input('licenseManager') licenseManager: LicenseManager;
    @Input('Subscriptions') Subscriptions;

    // Registry Editor
    CurrentRegistryKey: string;
    RegistryClientConnected: boolean = false;
    RegistrySubKeys: RegistrySubKeyItemArray = new RegistrySubKeyItemArray();
    RegistryValues: RegistryValueItemArray = new RegistryValueItemArray();
    RegistryFilter: string = '';

    registryResultRows: number = 100;
    registryFirstResult: number = 0;
    registryLastResult: number = 99;

    constructor(private liveHub: LiveHubService, private sweetAlert: SweetAlertService, private registryFilter: registryFilter, private api: ssApiService, public roles: UserRolesService, private dialogService: DialogService) { }

    ngOnInit() {
        // this.IsBusy = true;
        this.InitRegistryEditor();
    }

    InitRegistryEditor() {
        let registryBrowseSubscription = this.liveHub.RegistryBrowseResponse.subscribe(response => {
            this.IsBusy = false;
            this.RegistryClientConnected = true;
            if (response.LicenseKey == this.licenseManager.License().Key) {
                if (response.CurrentPage == 1) {
                    this.RegistrySubKeys = response.SubKeys;
                    this.RegistryValues = response.Values;
                } else {
                    this.RegistrySubKeys.push(...response.SubKeys);
                    this.RegistryValues.push(...response.Values);
                }
            }
        });

        let registrySubscription = this.liveHub.RegistryResponse.subscribe(response => {
            this.IsBusy = false;
            if (response.Result && response.LicenseKey == this.licenseManager.License().Key) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success!',
                    text: 'Registry value has been updated successfully',
                    timer: 1500
                }).then( () => {}, () => {} );
            }
        });

        this.Subscriptions.push(registryBrowseSubscription);
        this.Subscriptions.push(registrySubscription);
    }

    ConnectRegistryEditorToClient() {
        this.IsBusy = true;
        let request: AdminHubRegistryRequest = {
            LicenseKey: this.licenseManager.License().Key,
            RootString: 'currentuser',
            SubKey: '%structure_studios_root%'
        };
        this.CurrentRegistryKey = '%structure_studios_root%';
        this.liveHub.InvokeConnection('BrowseLicenseRegistry', request);
    }

    ReloadSubKey() {
        this.IsBusy = true;
        let request: AdminHubRegistryRequest = {
            LicenseKey: this.licenseManager.License().Key,
            RootString: 'currentuser',
            SubKey: this.CurrentRegistryKey
        };

        this.liveHub.InvokeConnection('BrowseLicenseRegistry', request);
    }

    GoToSubKey(subkey) {
        this.IsBusy = true;
        let key = this.CurrentRegistryKey + '\\' + subkey;
        let request: AdminHubRegistryRequest = {
            LicenseKey: this.licenseManager.License().Key,
            RootString: 'currentuser',
            SubKey: key
        };
        this.RegistryFilter = '';
        this.CurrentRegistryKey = key;
        this.liveHub.InvokeConnection('BrowseLicenseRegistry', request);
    }

    GoToParentRegistryKey() {
        this.IsBusy = true;
        let parent = this.CurrentRegistryKey.replace(new RegExp(/\\[^\\]*$/), '');
        let request: AdminHubRegistryRequest = {
            LicenseKey: this.licenseManager.License().Key,
            RootString: 'currentuser',
            SubKey: parent
        };
        this.RegistryFilter = '';
        this.CurrentRegistryKey = parent;
        this.liveHub.InvokeConnection('BrowseLicenseRegistry', request);
    }

    UpdateRegistryValue(item) {
        if (item.Editable) {

            this.IsBusy = true;

            let request: AdminHubRegistryRequest = {
                LicenseKey: this.licenseManager.License().Key,
                RootString: 'currentuser',
                SubKey: this.CurrentRegistryKey,
                Key: item.ValueName,
                Value: item.Value,
                ValueKind: item.ValueKind
            };

            this.liveHub.InvokeConnection('EditLicenseRegistryValue', request);
        }
    }

    AddRegistryValue() {
        this.IsBusy = true;
        let disposable = this.dialogService.addDialog(AddRegistryValueDialog, {
            title: 'Add New',
            LicenseKey: this.licenseManager.License().Key,
            SubKey: this.CurrentRegistryKey
        }, { height: 650 }).subscribe(() => {
            disposable.unsubscribe();
            this.ReloadSubKey();
        }, error => {
            disposable.unsubscribe();
        });
    }

    paginateRegistry(e) {
        this.registryFirstResult = e.page * e.rows;
        this.registryLastResult = this.registryFirstResult + e.rows;
    }

    FilteredRegistryValueCount(): number {
        return this.registryFilter.transform(this.RegistryValues, this.RegistryFilter).length;
    }

    StrippedFolderName(folder) {
        return folder.replace(new RegExp('%', 'g'), '');
    }

}
